import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type CreateFilterSetV3 = OpalApi<'CreateFilterSetV3', 201>

export const createFilterSet: CreateFilterSetV3 = async (args = {}) => {
  const url = new URL('/loupe/v3/filter_sets', window.location.origin)

  return HttpClient()
    .post(url.toString(), args.requestBody)
    .then((res) => res.data)
}
